export enum EnvironmentVariableErrorCode {
  Invalid = 'Invalid',
  Missing = 'Missing',
  Unknown = 'Unknown',
}

export const isEnvironmentVariableErrorCode = (
  value: unknown,
): value is EnvironmentVariableErrorCode =>
  Object.values(EnvironmentVariableErrorCode).includes(value as EnvironmentVariableErrorCode);
